import { Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { resolveAstralIconClass } from '../astral-icon-class.util';

@Component({
  selector: 'astral-field-action',
  standalone: true,
  imports: [TranslatePipe],
  template: `
    @if (href) {
    <a
      class="astral-field-action"
      [class.astral-field-action--disabled]="disabled"
      [attr.href]="disabled ? null : href"
      [attr.aria-disabled]="disabled ? 'true' : null"
      [attr.title]="resolvedTitle ? (resolvedTitle | translate) : null"
      [attr.aria-label]="resolvedAriaLabel ? (resolvedAriaLabel | translate) : null"
      [attr.target]="target || null"
      [attr.rel]="target === '_blank' ? 'noopener noreferrer' : null"
      (click)="handleDisabledClick($event)"
    >
      @if (resolvedIconClass) {
      <i
        class="astral-field-action__icon"
        [class]="'astral-field-action__icon ' + resolvedIconClass"
        aria-hidden="true"
      ></i>
      } @else {
        <span class="astral-field-action__label">{{ resolvedLabel | translate }}</span>
      }
    </a>
    } @else {
      <button
        type="button"
        class="astral-field-action"
        [class.astral-field-action--disabled]="disabled"
        [disabled]="disabled"
        [attr.title]="resolvedTitle ? (resolvedTitle | translate) : null"
        [attr.aria-label]="resolvedAriaLabel ? (resolvedAriaLabel | translate) : null"
      >
        @if (resolvedIconClass) {
        <i
          class="astral-field-action__icon"
          [class]="'astral-field-action__icon ' + resolvedIconClass"
          aria-hidden="true"
        ></i>
        } @else {
          <span class="astral-field-action__label">{{ resolvedLabel | translate }}</span>
        }
      </button>
    }
  `,
  styleUrls: ['./astral-field-action.component.scss'],
})
export class AstralFieldActionComponent {
  @Input() ariaLabel: string;
  @Input() ariaLabelKey: string;
  @Input() href: string;
  @Input() icon: string;
  @Input() label: string;
  @Input() labelKey: string;
  @Input() target: string;
  @Input() title: string;
  @Input() titleKey: string;
  @Input() disabled = false;

  get resolvedAriaLabel(): string | null {
    return this.ariaLabelKey ?? this.ariaLabel ?? this.resolvedTitle;
  }

  get resolvedIconClass(): string | null {
    return resolveAstralIconClass(this.icon);
  }

  get resolvedLabel(): string {
    return this.labelKey ?? this.label ?? '';
  }

  get resolvedTitle(): string | null {
    return this.titleKey ?? this.title ?? null;
  }

  handleDisabledClick(event: Event): void {
    if (!this.disabled) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
  }
}
